<template>
    <div>
        <a-row type="flex" style="margin-bottom: 12px">
            <a-col  style="padding-left: 12px" flex="1 1 200px">
                <strong style="font-size: 25px">Perspektif & Indikator</strong>
            </a-col>
            <a-col flex="0 1 300px">
                <a-select @change="handleChange" style="width: 100%" default-value="performance">
                    <a-select-option key="classical" value="classical">
                        Klasikal
                    </a-select-option>
                    <a-select-option key="paper" value="paper">
                        Makalah
                    </a-select-option>
                    <a-select-option key="project" value="project">
                        Project Management
                    </a-select-option>
                    <a-select-option key="performance" value="performance">
                        Performance
                    </a-select-option>
                    <a-select-option key="evaluation" value="evaluation">
                        Evaluasi
                    </a-select-option>
                </a-select>
            </a-col>
        </a-row>

        <a-card type="inner" size="small" >
            <a-table
                class="pcp-table"
                :columns="columns"
                :dataSource="tableData"
                :loading="loading"
                rowKey="hash"
                :pagination="false"
                childrenColumnName=""
                :rowClassName="(r) => r.is_heading ? 'row-heading' : '' "
                bordered
                >

                <div slot="no" slot-scope="record" class="text-small text-left" v-show="! record.is_heading">
                    {{ record.idx }}
                </div>

                <div slot="module" slot-scope="record" class="text-small text-left">
                    <template v-if="record.is_heading">
                        <strong>Aspek: {{ record.name }}</strong>
                    </template>
                    <template v-else>
                        {{ record.name }}
                    </template>
                </div>

                <div slot="short_code" slot-scope="record" class="text-small text-left" v-show="! record.is_heading">
                    {{ record.short_code }}
                </div>

                <div slot="code" slot-scope="record" class="text-small text-left" v-show="! record.is_heading">
                    {{ record.code }}
                </div>

                <div slot="indicator" slot-scope="record" class="text-small text-center" v-show="! record.is_heading">
                    <a-tooltip title="Indicator">
                        <a-button size="small" icon="eye" @click="indicator(record.parent, record.hash)" />
                    </a-tooltip>
                </div>

                <div slot="updated_at" slot-scope="record" class="text-small text-center" v-show="! record.is_heading">
                    <template v-if="record.updated_at != null">
                        {{ moment(record.updated_at).format('DD-MM-YYYY HH:mm:ss') }}
                    </template>
                </div>

                <div slot="action" slot-scope="record" style="text-align: center">
                    <a-space>
                        <a-tooltip title="Tambah" v-if="record.is_heading">
                            <a-button size="small" type="primary" icon="plus" @click="showModalAdd(record)" />
                        </a-tooltip>
                        <a-tooltip title="Edit" v-else>
                            <a-button size="small" type="primary" icon="edit" @click="showModal(record.hash)" />
                        </a-tooltip>
                    </a-space>
                </div>
            </a-table>
        </a-card>

        <a-modal
            :destroyOnClose="true"
            :footer="null"
            :visible="visible"
            :closable="false"
        >
            <admin-setting-perspective-form
                :aspect="aspect"
                :aspect_name="aspect_name"
                @handleClose="closeModal"
            />
        </a-modal>
    </div>
</template>

<script>

const columns = [
    {
		key: 'no',
		title: 'No',
        align: 'center',
        width: 60,
		scopedSlots: {customRender: 'no'},
	}, {
		key: 'module',
		title: 'Perspektif',
        align: 'center',
		scopedSlots: {customRender: 'module'},
	}, {
		key: 'short_code',
		title: 'Short Code',
        align: 'center',
        width: '150px',
		scopedSlots: {customRender: 'short_code'},
	}, {
		key: 'code',
		title: 'Kode',
        align: 'center',
        width: '150px',
		scopedSlots: {customRender: 'code'},
	}, {
		key: 'indicator',
		title: 'Indikator',
        align: 'center',
        width: '100px',
		scopedSlots: {customRender: 'indicator'},
	}, {
        key: 'updated_at',
        title: 'Last Update',
        align: 'center',
        width: '180px',
        scopedSlots: {customRender: 'updated_at'}
    }, {
		key: 'action',
		title: 'Action',
		align: 'center',
        width: '180px',
		scopedSlots: {customRender: 'action'}
	}
]

export default {
    data() {
        return {
            columns,
            loading: false,
            items: {
                data: []
            },
            filters: {
                q: null,
                module: 'performance',
                type: 'aspect',
                with: 'children'
            },
            hash: null,
            aspect: null,
            aspect_name: null,
            visible: false,
        }
    },
    created() {
        this.getItems()
    },
    computed: {
        tableData() {
            let collection = []

            this.items.data.forEach(function (item, index) {
                collection.push({
                    idx: 0,
                    parent: null,
                    hash: item.hash,
                    is_heading: true,
                    name: item.name,
                    code: item.code,
                    short_code: item.short_code,
                    updated_at: item.updated_at
                })
            
                let idx = 0

                item.children.forEach(function (itemChild, index) {
                    idx++
                    collection.push({
                        idx: idx,
                        parent: item.hash,
                        hash: itemChild.hash,
                        is_heading: false,
                        name: itemChild.name,
                        code: itemChild.code,
                        short_code: itemChild.short_code,
                        updated_at: itemChild.updated_at
                    })
                })
            })

            return collection
        }
    },
    methods: {
        getItems() {
            this.loading = true;
            this.$http
                .get(this.routeUri('api.category'), {
                    params: this.filters
                })
                .then(response => this.items = response.data)
                .catch(error => this.handleXhrError(error))
                .finally(() => (this.loading = false));
        },
        showModal(hash) {
            this.hash = hash;
            this.visible = true;
        },
        showModalAdd(record) {
            this.aspect = record.hash;
            this.aspect_name = record.name;
            this.visible = true;
        },
        closeModal(isRefresh) {
            this.visible = false;

            if (isRefresh == true) {
                this.getItems();
            }
        },
        handleChange(value) {
            this.filters.module = value

            this.getItems()
        },
        indicator(aspect, perspective) {
            let params = {
                perspective: perspective
            }

            window.location.href = this.routeUri('admin.setting.indicator') + '?' + this.$qs.stringify(params)
        }
    },
}
</script>
